export default __webpack_public_path__ + "static/media/Logo Vettoriale settembre2015.df366170.png";